/**
 * @author Omar BERRABEH
 * @license Givaudan
 */

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AccountService } from '@banyan/modules/account/services/account.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocaleInterceptor implements HttpInterceptor {
  accountService = inject(AccountService);

  constructor() {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.method === 'GET' && req.url.includes(environment.middlewareUrl)) {
      const newReq = req.clone({
        setParams: {
          locale: this.accountService.user().preferredLanguage,
        },
      });
      return next.handle(newReq);
    }

    return next.handle(req);
  }
}
